var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-form',[_c('input-last-name'),_c('input-first-name'),_c('input-email')],1)}
var staticRenderFns = []

export { render, staticRenderFns }